"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("@dom/config"));

var _utils = require("@dom/utils");

var INITIAL_STATE = {
  error: '',
  file: null,
  progress: 0,
  isUploading: false,
  imagePreviewUrl: ''
};

var ImageUploader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ImageUploader, _Component);

  function ImageUploader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ImageUploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ImageUploader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", INITIAL_STATE);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleImageChange", function (e) {
      e.stopPropagation();
      e.preventDefault(); // console.log(e.target.files);

      var file = e.target.files;
      var files = Array.from(file);

      _this.setState({
        file: files
      });

      var _loop = function _loop(i) {
        var reader = new FileReader();
        reader.readAsDataURL(file[i]);

        reader.onloadend = function () {
          _this.setState({
            imagePreviewUrl: [].concat((0, _toConsumableArray2["default"])(_this.state.imagePreviewUrl), [reader.result])
          });
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadImage", function () {
      _this.setState({
        isUploading: true,
        error: ''
      });

      _this.upload();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelEdit", function () {
      _this.setState(INITIAL_STATE);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onUploadProgress", function (e) {
      _this.setState({
        progress: Math.round(e.loaded / e.total * 100)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "upload",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var fd, file, onUploadFail;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fd = new FormData();
              file = _this.state.file;
              onUploadFail = _this.props.onUploadFail;
              file.forEach(function (file) {
                fd.append('file', file, {
                  'Content-Type': 'image/jpeg'
                });
              });
              _context.prev = 4;
              _context.next = 7;
              return (0, _axios["default"])({
                method: 'PUT',
                url: "".concat(_config["default"].ENDPOINT, "/").concat(_this.props.uploadUrl),
                data: fd,
                headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: "JWT ".concat((0, _utils.getToken)()),
                  Accept: 'application/json'
                },
                onUploadProgress: _this.onUploadProgress
              });

            case 7:
              window.location.reload();
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              onUploadFail && onUploadFail(_context.t0);

              _this.setState({
                isUploading: false,
                error: _context.t0.response ? _context.t0.response.data.message : 'Could not upload your image. Please try again later.',
                progress: 0
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 10]]);
    })));
    return _this;
  }

  (0, _createClass2["default"])(ImageUploader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          file = _this$state.file,
          imagePreviewUrl = _this$state.imagePreviewUrl,
          progress = _this$state.progress,
          isUploading = _this$state.isUploading,
          error = _this$state.error;
      var _this$props = this.props,
          children = _this$props.children,
          pageContext = _this$props.pageContext,
          role = _this$props.role,
          multiple = _this$props.multiple;
      return _react["default"].createElement(_react.Fragment, null, children(imagePreviewUrl), role ? _react["default"].createElement("div", {
        className: isUploading ? 'progress-bar-holder uploading' : 'progress-bar-holder'
      }, _react["default"].createElement("div", {
        className: "progress-bar",
        role: "progressbar",
        style: {
          width: progress + '%'
        }
      }, _react["default"].createElement("span", {
        className: "sr-only"
      }, progress, "% Complete"))) : null, role ? _react["default"].createElement("div", {
        className: "uploader ".concat(pageContext)
      }, _react["default"].createElement("p", {
        className: "error"
      }, error), _react["default"].createElement("input", {
        style: {
          display: 'none'
        },
        type: "file",
        accept: "image/*",
        multiple: multiple,
        onChange: this.handleImageChange,
        ref: function ref(input) {
          _this2.fileInput = input;
        }
      }), _react["default"].createElement(_reactstrap.Button, {
        color: "primary",
        className: pageContext,
        onClick: function onClick() {
          return _this2.fileInput.click();
        }
      }, "Change Image"), file ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.Button, {
        color: "primary",
        className: pageContext,
        onClick: this.uploadImage
      }, "Save"), _react["default"].createElement(_reactstrap.Button, {
        color: "primary",
        className: pageContext,
        onClick: this.cancelEdit
      }, "Cancel")) : null) : null);
    }
  }]);
  return ImageUploader;
}(_react.Component);

exports["default"] = ImageUploader;
(0, _defineProperty2["default"])(ImageUploader, "defaultProps", {
  onUploadFail: function onUploadFail() {}
});